export const prepareForFuzzyMatch = (candidate = '') =>
    candidate.toLowerCase().replace(/-/g, ' ').replace(/'/g, '').replace(/ /g, '');

export const hasFuzzyMatch = (datum, query) =>
    prepareForFuzzyMatch(datum).indexOf(prepareForFuzzyMatch(query)) > -1;

export default {
    hasFuzzyMatch: hasFuzzyMatch,
    prepareForFuzzyMatch: prepareForFuzzyMatch,
};
